/** Same owner and contact merge (spec docs/superpowers/specs/2026-10-25-same-owner-and-merge-design.md). */
import { oc } from '@orpc/contract';
import { z } from 'zod';
export const accountGroupInput = z.object({ accountId: z.uuid(), withAccountId: z.uuid() });
export const accountGroupOutput = z.object({ legalEntityId: z.uuid(), locations: z.number().int() });
export const accountSeparateInput = z.object({ accountId: z.uuid() });
export const contactMergeInput = z.object({ keepContactId: z.uuid(), mergeContactId: z.uuid() });
export const contactMergeOutput = z.object({ contactId: z.uuid(), movedToOwner: z.boolean() });
export const accountGroupRoutes = {
    group: oc.route({ method: 'POST', path: '/accounts/group', summary: 'Group two stores under one owner' }).input(accountGroupInput).output(accountGroupOutput),
    separate: oc.route({ method: 'POST', path: '/accounts/separate', summary: 'Take a store out of a desk-made owner group' }).input(accountSeparateInput).output(z.object({ ok: z.literal(true) })),
};
export const contactsContract = {
    merge: oc.route({ method: 'POST', path: '/contacts/merge', summary: 'Fold one contact into another, under the same store or owner' }).input(contactMergeInput).output(contactMergeOutput),
};
//# sourceMappingURL=identity.js.map